// extracted by mini-css-extract-plugin
module.exports = {"container":"UgcPlayer_container__7NTUJ","playerContainer":"UgcPlayer_playerContainer__QmFOd"};